import React from 'react';
import { Section } from './ui/Section';
export function ProductShowcase() {
  return <Section background="white" className="!py-4 md:!py-8" data-id="element-373">
      <div className="max-w-4xl mx-auto" data-id="element-374">
        <div className="relative" data-id="element-375">
          {/* Main image container */}
          <div className="rounded-3xl overflow-hidden shadow-2xl border-8 border-white bg-white" data-id="element-376">
            <img src="https://cdn.magicpatterns.com/uploads/bdWwQ78aXBtw9qJ7m4CGMx/image.png" alt="No es falta de paciencia. Es falta de claridad. Rutinas visuales - Descarga inmediata" className="w-full h-auto object-contain" data-id="element-377" />
          </div>
        </div>
      </div>
    </Section>;
}